// A product is "新品" if it was created within the configured window (设置 → 新品天数,
// default 14 days). Prefer FileMaker creation date (fm_creation_date, ISO yyyy-mm-dd)
// when present, otherwise fall back to the system created_at timestamp.
const DAY_MS = 24 * 3600 * 1000;

export function newProductDays() {
  const n = Number(window.__quotesys_new_product_days__);
  return n > 0 ? n : 14;
}

export function setNewProductDays(days) {
  const n = Number(days);
  if (n > 0) window.__quotesys_new_product_days__ = n;
}

export function isNewProduct(product) {
  if (!product) return false;
  // 2026-06 · 产品类型为空（还没归类）的也算新品
  const types = product.product_types || [];
  if (!product.product_type && types.length === 0) return true;
  const windowMs = newProductDays() * DAY_MS;
  const now = Date.now();
  if (product.fm_creation_date) {
    const ts = Date.parse(`${product.fm_creation_date}T00:00:00Z`);
    if (!Number.isNaN(ts)) return now - ts <= windowMs;
  }
  if (product.created_at) {
    const ts = Date.parse(product.created_at);
    if (!Number.isNaN(ts)) return now - ts <= windowMs;
  }
  return false;
}
